import React from 'react';
import PropTypes from 'prop-types';
import {
	Drawer as ToolkitDrawer,
	DrawerHeader as ToolkitDrawerHeader,
	DrawerBody as ToolkitDrawerBody,
	DrawerFooter as ToolkitDrawerFooter,
} from '@quantum-ecosystem/ui-toolkit';

export const FormDrawer = ({
	opened,
	show,
	onClose,
	onHide,
	title,
	subtitle,
	position = 'right',
	placement,
	size = 'md',
	withCloseButton = true,
	closeOnClickOutside = true,
	className,
	bodyClassName,
	children,
	...restProps
}) => {
	const isVisible = Boolean(show ?? opened);
	const handleClose = onHide || onClose || (() => {});
	const handleDrawerHide = closeOnClickOutside ? handleClose : () => {};

	const effectivePlacement = placement || position || 'right';

	// Map drawer sizes
	let toolkitSize = 'md';
	let sizeClassName = '';

	if (size === 'sm') {
		toolkitSize = 'sm';
	} else if (size === 'md') {
		toolkitSize = 'md';
	} else if (size === 'lg') {
		toolkitSize = 'lg';
	} else if (size === 'full') {
		toolkitSize = 'full';
	} else if (size === '80%') {
		sizeClassName = 'q-drawer-size-80';
		toolkitSize = 'lg';
	} else if (size === '90%') {
		sizeClassName = 'q-drawer-size-90';
		toolkitSize = 'lg';
	} else if (size === 'xl') {
		sizeClassName = 'q-drawer-size-xl';
		toolkitSize = 'lg';
	}

	const combinedClassName = [sizeClassName, className]
		.filter(Boolean)
		.join(' ');

	const hasHeader = (title !== undefined && title !== null) || withCloseButton;

	return (
		<ToolkitDrawer
			show={isVisible}
			onHide={handleDrawerHide}
			placement={effectivePlacement}
			size={toolkitSize}
			className={combinedClassName}
			{...restProps}
		>
			{hasHeader ? (
				<>
					<ToolkitDrawerHeader
						title={title}
						subtitle={subtitle}
						onHide={withCloseButton ? handleClose : undefined}
					/>
					<ToolkitDrawerBody className={bodyClassName}>
						{children}
					</ToolkitDrawerBody>
				</>
			) : (
				children
			)}
		</ToolkitDrawer>
	);
};

FormDrawer.Header = ToolkitDrawerHeader;
FormDrawer.Body = ToolkitDrawerBody;
FormDrawer.Footer = ToolkitDrawerFooter;

FormDrawer.propTypes = {
	opened: PropTypes.bool,
	show: PropTypes.bool,
	onClose: PropTypes.func,
	onHide: PropTypes.func,
	title: PropTypes.node,
	subtitle: PropTypes.node,
	position: PropTypes.oneOf(['left', 'right']),
	placement: PropTypes.oneOf(['left', 'right']),
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	withCloseButton: PropTypes.bool,
	closeOnClickOutside: PropTypes.bool,
	className: PropTypes.string,
	bodyClassName: PropTypes.string,
	children: PropTypes.node,
};

export default FormDrawer;
